// 注册
<template>
  <div class="register">
    <van-nav-bar
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
      :title="$t('register.register')"
    ></van-nav-bar>

    <section class="form">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.email"
          name="email"
          :placeholder="$t('placeholder.email')"
        />
        <van-field
          v-model="form.verificationCode"
          name="verificationCode"
          :placeholder="$t('placeholder.verifiy')"
        >
          <template #button>
            <div class="verify-btn" @click="getCode">
              {{ second < 60 ? `${second}s` : "verification code" }}
            </div>
          </template>
        </van-field>
        <van-field
          v-model="form.password"
          name="password"
          type="password"
          :placeholder="$t('placeholder.password')"
        />
        <div style="margin: 20px 25px; 0;">
          <van-checkbox v-model="isCookies" shape="square" class="tips"
            >Accept
            <a
              @click="toIframeWithBar('https://appweb.arcticdolphin.net/agreement/cookiesEn.html')"
              >Cookies Policy.</a
            ></van-checkbox
          >
          <span class="tips_desc"
            >Cookies help us remember you. keep you signed in, and imprrove your
            experience across our site.</span
          >
          <van-checkbox v-model="isPrivacy" shape="square" class="tips"
            >I have read and consent to
            <a
              @click="toIframeWithBar('https://appweb.arcticdolphin.net/agreement/PrivacyAgreementEn.html')"
              >Privacy Policy.</a
            ></van-checkbox
          >
        </div>
        <div style="margin: 24px 25px 0">
          <van-button
            class="submit"
            block
            round
            size="large"
            color="linear-gradient(30deg, #3EE191, #24DEDD)"
            type="info"
            native-type="submit"
          >
            {{ $t("register.register") }}
          </van-button>
        </div>
      </van-form>
    </section>
  </div>
</template>

<script>
import { getVerificationCode, register, customerInfo } from "@/api";
import { setCookies } from "@/libs/util";
const count = 60;
export default {
  name: "Register",
  data() {
    return {
      second: count,
      secondTimer: null,
      form: {
        email: "",
        verificationCode: "",
        password: "",
      },
      isCookies: true,
      isPrivacy: true,
    };
  },
  watch: {
    second(val) {
      if (val === 0) {
        clearInterval(this.secondTimer);
        this.secondTimer = null;
        this.second = count;
      }
    },
  },
  methods: {
    // 邮箱验证
    validatorEmail(value) {
      const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      return reg.test(value);
    },
    // 获取验证码
    getCode() {
      if (this.second < 60) {
        return;
      }
      if (!this.form.email) {
        this.$toast(this.$t("placeholder.email"));
        return;
      }
      this.$toast.loading({
        duration: 0,
      });
      getVerificationCode({
        email: this.form.email,
        type: 1,
      })
        .then((res) => {
          this.$toast.success(res.msg);
          this.secondTimer = setInterval(() => {
            this.second--;
          }, 1000);
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    // 表单提交
    onSubmit() {
      if (!this.form.email) {
        this.$toast(this.$t("placeholder.email"));
        return;
      } else {
        // 邮箱验证
        if (!this.validatorEmail(this.form.email)) {
          this.$toast(this.$t("placeholder.email"));
          return;
        }
      }
      if (!this.form.verificationCode) {
        this.$toast(this.$t("placeholder.verifiy"));
        return;
      }
      if (!this.form.password) {
        this.$toast(this.$t("placeholder.password"));
        return;
      }
      register({
        email: this.form.email,
        verificationCode: this.form.verificationCode,
        imie: this.$store.state.app.imie,
        password: this.$md5(this.form.password).toUpperCase(),
      }).then((res) => {
        sessionStorage.setItem("token", res.data.token);
        this.$store.commit("setToken", res.data.token);
        setCookies("account", this.form, 30);
        if (window.webkit) {
          window.webkit.messageHandlers.whenTokenReceived.postMessage(
            res.data.token
          ); // 向宿主发送token
        }
        customerInfo().then((res) => {
          console.log("顾客信息", res.data);
          sessionStorage.setItem("userInfo", JSON.stringify(res.data));
          this.$store.commit("setUserInfo");
        });

        console.info("准备设置跳转定时器");
        this.$toast.success(res.msg);
        setTimeout(() => {
          console.info("开始执行跳转定时器");
          this.$router.push("home");
        }, 1000);
        console.info("已设置跳转定时器");
      });
    },
    /** 跳转到外部连接 */
    toIframeWithBar(url) {
      this.$router.push({
        name: "iframeWithBar",
        params: {
          urlOfIframe: url,
        },
      });
    },
  },
};
</script>

<style lang="less">
.register {
  box-sizing: border-box;
  min-height: 100vh;
  height: 100%;
  padding: 24px;
  .verify-btn {
    text-align: center;
    width: 180px;
    border: 1px solid #d2d2d2;
    color: #797979;
    font-size: 18px;
    background: transparent;
    padding: 10px 14px;
    border-radius: 40px;
  }
  .van-cell {
    background: transparent;
    padding: 30px 40px;
    &:after {
      border-color: #d2d2d2;
    }
  }
  .van-nav-bar {
    background: #fff !important;
    .van-nav-bar__title {
      color: #000;
      width: 80%;
      max-width: 80%;
      font-weight: normal !important;
    }
  }
  .van-field__label {
    color: #c8c9cc;
  }
  .tips {
    color: #404040;
    font-size: 26px;
    font-weight: 500;
    a {
      color: #1667b2;
      text-decoration: underline;
    }
  }
  .tips_desc {
    display: flex;
    color: #797979;
    font-size: 18px;
    margin: 8px 0 15px;
  }
}
</style>
